export function parseAxiosError(response: { data: { message: any } }): string {
  const message = response.data.message
  if (typeof message === "string") {
    if (message.includes("Not authorized.")) {
      return "Dir fehlen hierfür die nötigen Rechte."
    } else {
      return "Ein unbekannter Fehler ist aufgetreten."
    }
  }
  const keys = Object.keys(message)
  const errors = keys.map((key) => {
    return `${key}: ${message[key].join(", ")}`
  })
  return errors.join("\n")
}
